module.exports = __webpack_public_path__ + "static/img/login-l.9089a84.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/image/login-l.png
// module id = H/Mw
// module chunks = 1